module.exports = __webpack_public_path__ + "static/media/doug-dold.3f35a9e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/doug-dold.jpg
// module id = 20
// module chunks = 0